import App from '../app'
import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import categories from './modules/categories'
import charts from './modules/charts'
import general from './modules/general'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  plugins: App.isDebug ? [createLogger()] : [],
  modules: {
    cart,
    categories,
    charts,
    general
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js